import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ForestIcon(props: IconProps) {
    return <Icon {...props} iconKey={"forest"}/>
}
